import React from "react";
import PaginaRecursos from "./PaginaRecursos";
import Seleccionareina, { idEina } from "./Seleccionareina";
import Detallseina from "./Detallseina";

const CONFIG = {
  titol: "Eines",
  subtitol: "Eines reutilitzables de l'empresa, amb el seu estat i l'última ubicació coneguda.",
  icona: "🛠️",
  textNou: "Nova eina",
  pestanyaAjuda: "eines",
  idDe: idEina,
  Llista: Seleccionareina,
  Fitxa: Detallseina,
};

function Eines() {
  return <PaginaRecursos config={CONFIG} />;
}

export default Eines;
